import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=ab173ec2&"
import script from "./goodsItem.vue?vue&type=script&lang=js&"
export * from "./goodsItem.vue?vue&type=script&lang=js&"
import style0 from "./goodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports